import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useScaling } from '@domain/hooks';
import { isMobile } from 'react-device-detect';

const StyledList = styled('ul', {
  shouldForwardProp: (propName) => !propName.startsWith('$')
})`
  width: ${props => props.$isMobile ? '100%' : 'inherit'};
  display: flex;
  justify-content: space-between;
  padding: ${props => props.$scaling.scaleUpTo4K(10)}px ${props => props.$scaling.scaleUpTo4K(2)}px;
  .screen-desktop & {
  padding: ${props => props.$scaling.scaleUpTo4K(20)}px ${props => props.$scaling.scaleUpTo4K(2)}px; 
  }
`;

function ImageViewerContainer({ children }) {
  const scaling = useScaling()
  return (
    <StyledList $scaling={scaling} $isMobile={isMobile} className="image__viewer__container">
      {React.Children.toArray(children)}
    </StyledList>
  );
}

ImageViewerContainer.propTypes = {
  children: PropTypes.any.isRequired
};

export default ImageViewerContainer;
